export const UPDATE_GROUP_STATE = 'UPDATE_GROUP_STATE'
export const GROUP_DELETED = 'GROUP_DELETED'